module.exports = __webpack_public_path__ + "static/media/XPTUSD.5f354afb.svg";